import React, { useState } from "react";
import { ChatWindow } from "../types";

interface Props {
  tabs: string[];
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
}

export default function TabBar({ tabs, selectedTab, setSelectedTab }: Props) {
  return (
    <div className="border-b border-slate-200 px-4 mb-4">
      <nav className="flex justify-center space-x-6">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setSelectedTab(tab)}
            className={`relative py-3 text-sm font-medium transition-colors duration-150 ${
              selectedTab === tab
                ? "text-cornflower-blue-500"
                : "text-slate-600 hover:text-cornflower-blue-500"
            }`}
          >
            {tab}
            {selectedTab === tab && (
              <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-cornflower-blue-500" />
            )}
          </button>
        ))}
      </nav>
    </div>
  );
}
